import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaStar } from 'react-icons/fa'; // Font Awesome Star
import img1 from'./images/1img.webp';
import img2 from'./images/2img.webp';
import img4 from'./images/A1.webp';
import img5 from'./images/A2.webp';
import img6 from'./images/A4.webp';
import img7 from'./images/A5.webp';
import img8 from'./images/b1.webp';
import img9 from'./images/b2.webp';
import img0 from'./images/b4.webp';
import img3 from'./images/b5.webp';
import imgx from'./images/Swarnika.webp';
import imgy from'./images/N1.avif';
import imgz from'./images/N2.avif';
import imga from'./images/N4.avif';
import imgb from'./images/N5.avif';
import imgt from'./images/N6.avif';
import { FaSearch, FaShoppingBag, FaUser, FaBars } from 'react-icons/fa';

function App() {
  return (
    <>
    <div class="App">
    <h2>FESTIVE HAMPERS WITH ALL ORDERS ABOVE ₹1890 |FREE SHIPPING</h2>
    </div>
    <div class="navbar">
    <FaBars/> {/* Toggle (Menu) Button Icon */}
    <h1 class="title" >RASHKI</h1>
    <div class="nav">
    <FaSearch /> {/* Magnifying Glass Icon */}
    <FaShoppingBag /> {/* Bag Icon */}
    <FaUser /> {/* Profile Icon */}
    </div>

    </div>
    <div className="hng">
    <img src={img1} alt=""/>
    </div>
    <h1 class="txt">HERE’S WHATS HAPPENING</h1>
    <div className="xng">
    <img src={img2} alt=""/>
    </div>
    <h2  class="nxt">Shop our Favourites</h2>
    <div class="jbg">
    <img src={img4} alt=""/>
    <img src={img5} alt=""/>
    <img src={img6} alt=""/>
    <img src={img7} alt=""/>
    </div>
    <div class="jbg">
    <img src={img8} alt=""/>
    <img src={img9} alt=""/>
    <img src={img0} alt=""/>
    <img src={img3} alt=""/>
    </div>
    <div className="container">

            <div className="image-section">
                <img src={imgx}alt="Description" />
            </div>
            <div className="text-section">
            <div class="yellow">
            <FaStar/> {/* Star Icon */}
            <FaStar/>
            <FaStar/>
            <FaStar/>
            <FaStar/>
            </div>
                <h1>SWARNIKA</h1>
                <p>The Fero Mini Bag is a commendable blend of style and functionality, making it an excellent choice for everyday use. The bag offers ample storage space with well-organized compartments, catering to both work and casual needs</p>
            </div>
        </div>
    <div>

    <h5 class="xt">We understand that you have a lot on your plate, together let’s #accomplishmore<br></br> Know more</h5>
    </div>
    <h1 class="txt">WE HAVE SOME NEWS!</h1>
    <div class="bg">
    <img src={imgy} alt=""/>
    <img src={imgz} alt=""/>
    <img src={imgt} alt=""/>
    <img src={imga} alt=""/>
    <img src={imgb} alt=""/>
    </div>
    <h2 class="txt">DELIVERY MORE</h2>
    <FontAwesomeIcon icon="fa-solid fa-truck-fast" />
    <hr/>
    <h4> CUSTOMER SERVICE</h4>
    <p>Shipping & Delivery Policy</p>
    <p>Return, Exchange and Refunds policy for Bags</p>
    <p>Return, Exchange and Refunds policy for heels</p>
    <p>Privacy Policy</p>
    <p>Terms of Service</p>
    <p>Intellectual Property & Trademarks
    Contact Us</p>
    <p>Contact Us</p>
    
    </>
    );
}
export default App;